import React, { ReactNode, useMemo } from 'react';
import { Select, MenuItem, FormControl, InputLabel, FormHelperText } from '@mui/material';
import { FormikProps } from "formik";

export interface Option {
    value: string|number
    label: string|ReactNode
}

export interface AbstractDropDownProps {
    options?: Option[]
    value?: string
    label: string|ReactNode
    name?: string
    error?: string|ReactNode
    submitHappen?: boolean
    onChange?:(value:string) => void
    formik?: FormikProps<unknown>
    disabled?: boolean
}

export function AbstractDropDown ({disabled, name,submitHappen, formik, value, label, options, error, onChange}:AbstractDropDownProps){
    const id = useMemo(() => Math.random() + "", []);
    if(formik && !name) {
        alert("name not defined, while formik defined");
    }
    //@ts-ignore
    const errorToDisplay = formik ? (submitHappen || formik.touched[name!]) && formik.errors[name!] : error;

    return (
        <FormControl variant="outlined" fullWidth>
            <InputLabel id={id}>{label}</InputLabel>
            <Select
                disabled={disabled}
                labelId="select-label"
                //@ts-ignore
                value={(value === undefined ? (formik ? (formik.values[name!] || '') : '') : value)}
                label={label}
                name={name}
                onChange={(e) => {
                    (onChange ? onChange(e.target.value) : (formik ? formik.handleChange(e) : (() => {})()))
                }}
                //@ts-ignore
                error={formik ? (submitHappen || formik.touched[name!]) && Boolean(formik.errors[name!]) : !!error}
            >
                {(options || []).map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                        {option.label}
                    </MenuItem>
                ))}
            </Select>
            {errorToDisplay && <FormHelperText error>
                {errorToDisplay}
            </FormHelperText>}
        </FormControl>
    );
};